/** WARNING RSE used ChatGPT 3 to generate this, Treat with caution!! */

export type EstimateLoRaAirtimeInput = {
  payloadBytes: number // in bytes
  sf: number // SF7 - SF12
  bw: number // in Hz (125000, 250000, 500000)
  codeRate: string // 4/5 -> 1, 4/6 -> 2, 4/7 -> 3, 4/8 -> 4
  preambleLength?: number | undefined // Default LoRa preamble length
  adr?: boolean | undefined // DE (enabled for SF11 & SF12)
  explicitHeader?: boolean | undefined // H (true = explicit header mode)
}
/** return estimated airtime in millisconds */
export const estimateLoRaAirtime = ({
  payloadBytes, // in bytes
  sf, // SF7 - SF12
  bw, // in Hz (125000, 250000, 500000)
  codeRate, // 4/5 -> 1, 4/6 -> 2, 4/7 -> 3, 4/8 -> 4
  preambleLength = 8, // Default LoRa preamble length
  adr = false, // DE (enabled for SF11 & SF12)
  explicitHeader = true, // H (true = explicit header mode)
}: EstimateLoRaAirtimeInput): number | undefined => {
  /** protection against bw scale */
  if (Math.floor(bw / 1000) === 0) {
    bw = bw * 1000
  }

  const cr: number | undefined = codeRateMap[codeRate]
  if (cr) {
    // Symbol time (ms)
    const Tsym = (2 ** sf / bw) * 1000

    // Preamble duration (ms)
    const Tpreamble = (preambleLength + 4.25) * Tsym

    // Payload symbol calculation
    const H = explicitHeader ? 0 : 1
    const DE = adr ? 1 : 0
    const payloadSymb = 8 + Math.max(Math.ceil((8 * payloadBytes - 4 * sf + 28 + 16 - 20 * H) / (4 * (sf - 2 * DE))) * (cr + 4), 0)

    // Payload duration (ms)
    const Tpayload = payloadSymb * Tsym

    // Total time on air (ms)
    return Tpreamble + Tpayload
  } else {
    return undefined
  }
}

const codeRateMap: { [k: string]: number } = {
  '4/5': 1,
  '4/6': 2,
  '4/7': 3,
  '4/8': 4,
}
